// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { HasOnError } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    InviteYourColleagueModel,
    UserNotificationInviteCollegueModel,
} from "@insite/client-framework/Types/ApiModels";

const tecUrl = "/api/v1/custom/inviteyourcolleague";

const nonLoggedInUrl = "/api/v1/custom/user";

export interface InviteYourColleagueApiParameter extends ApiParameter {
    inviteYourColleagueModel: InviteYourColleagueModel;
}
export interface GetNotificationPreferencesParameter extends ApiParameter {
    hash: string;
}

export async function submitInviteYourColleagueEmail(
    parameter: InviteYourColleagueApiParameter,
): Promise<ServiceResult<InviteYourColleagueModel>> {
    try {
        const inviteYourColleagueModel = await post<InviteYourColleagueModel>(
            `${tecUrl}`,
            parameter.inviteYourColleagueModel,
        );
        return {
            successful: true,
            result: inviteYourColleagueModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getCustomerInfo(
    parameter: GetNotificationPreferencesParameter & HasOnError,
): Promise<UserNotificationInviteCollegueModel> {
    try {
        const customerInfo = await get<UserNotificationInviteCollegueModel>(
            `${nonLoggedInUrl}/soldAndShipTos/${parameter.hash}`,
        );

        return customerInfo;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            parameter.onError?.(error.errorJson.message);
        }

        throw error;
    }
}
